import { ReactNode } from "react";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import Image from "next/image";
import useBrowserRoutes from "@/src/utils/helpers/useBrowserRoutes";
import { useHomePageContext } from "@/src/features/home/HomePageContext";
import { useAppContext } from "@/src/config/AppProvider";
import DateTimeHelper from "@/src/utils/helpers/DateTimeHelper";

const AnnouncementsSection = () => {
  const { t } = useTranslation();
  const routes = useBrowserRoutes();
  const { getLocalization } = useAppContext();

  return (
    <div className="rbt-events-area bg-color-white rbt-section-gap">
      <div className="container">
        <div className="row mb--60 g-5 align-items-end">
          <div className="col-lg-6 col-md-6 col-12">
            <div className="section-title text-start">
              <span className="subtitle bg-secondary-opacity">{t("announcements")}</span>
              <h2 className="title">{getLocalization("newAnnouncementsSlogan")}</h2>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="read-more-btn text-start text-md-end">
              <Link className="rbt-btn btn-gradient hover-icon-reverse radius-round" href={routes.announcements}>
                <div className="icon-reverse-wrapper">
                  <span className="btn-text">{t("allAnnouncements")}</span>
                  <span className="btn-icon">
                    <i className="feather-arrow-right"></i>
                  </span>
                  <span className="btn-icon">
                    <i className="feather-arrow-right"></i>
                  </span>
                </div>
              </Link>
            </div>
          </div>
        </div>
        <Announcements />
      </div>
    </div>
  );
};

const Announcements = (): ReactNode => {
  const { announcements } = useHomePageContext();
  const { t } = useTranslation();
  const routes = useBrowserRoutes();

  return (
    <div className="row g-5">
      {announcements.map(item => {
        const detailLink = routes.announcementDetail.replace(":slug", item.Slug);

        return (
          <div className="col-lg-6 col-md-6 col-12" key={item.IdGuid}>
            <div className={`rbt-card card-list-2 event-list-card variation-01 rbt-hover`}>
              <div className="rbt-card-img">
                <Link href={detailLink}>
                  <Image
                    src={item.ThumbImageUrl}
                    width={230}
                    height={200}
                    priority
                    alt={item.ImageAltText}
                    style={{
                      maxHeight: "200px",
                      objectFit: "cover"
                    }}
                  />
                </Link>
              </div>
              <div className="rbt-card-body">
                <ul className="rbt-meta">
                  <li>
                    <i className="feather-calendar"></i>
                    {DateTimeHelper.toDisplayDateTime(item.CreatingDateTime, "D MMMM, YYYY")}
                  </li>
                </ul>
                <h4 className="rbt-card-title">
                  <Link href={detailLink}>{item.Title}</Link>
                </h4>

                <div className="read-more-btn">
                  <Link className="rbt-btn btn-border hover-icon-reverse btn-sm radius-round" href={detailLink}>
                    <span className="icon-reverse-wrapper">
                      <span className="btn-text">{t("announcemenDetails")}</span>
                      <span className="btn-icon">
                        <i className="feather-arrow-right"></i>
                      </span>
                      <span className="btn-icon">
                        <i className="feather-arrow-right"></i>
                      </span>
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AnnouncementsSection;
